import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { QuestionCinTerm } from "./check-in-term";
import { QuestionDescription } from "./description";
import { QuestionCampaignEmailTemplates } from "./email-template";
import { QuestionExplanationForHost } from "./explanation-for-host";
import { QuestionCampaignKeyVisual } from "./key-visual";
import { QuestionCampaignName } from "./name";
import { QuestionResourceAvailablePrice } from "./resource-available-price";
import { QuestionVoucherPrice } from "./voucher-price";
import { useMarketingCampaignFormModelContext } from "../../context";

export const QuestionCampaignBase = () => {
	const {
		viewModel: { hotelID, voucherID },
	} = useMarketingCampaignFormModelContext();
	const ownerID = hotelID;
	const resourceID = voucherID;

	return (
		<FeatureIslandMainWithBackGround islandTitle="基本設定">
			<QuestionExplanationForHost />
			<QuestionCampaignName />
			<QuestionCampaignKeyVisual ownerID={ownerID} resourceID={resourceID} />
			<QuestionDescription />
			<QuestionCampaignEmailTemplates />
			<QuestionCinTerm />
			<QuestionVoucherPrice />
			<QuestionResourceAvailablePrice />
		</FeatureIslandMainWithBackGround>
	);
};

QuestionCampaignBase.displayName = "QuestionCampaignBase";
